import type { RouteObject } from 'react-router';

import * as searchVolopsHorizonRouteExports from '#/modules/search/volops/page/SearchVolops.horizon-route';
import { horizonRouteToObject } from '#/routing/utils/horizonRouteToObject';

import { searchVolopsRoutePaths } from './seachVolops.route-paths';

export const searchVolopsRouteObjects = searchVolopsRoutePaths.map((path) => ({
  path,
  ...horizonRouteToObject(searchVolopsHorizonRouteExports),
})) satisfies RouteObject[];
